module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("ILLUSTRATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent1"
  }, [_vm._v("The opening lines of the Grasmere Journals, 26")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("The back cover of the first notebook of the Grasmere Journals, 31")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Racedown, drawing by S. L. May, 78")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Scullery maid, drawing by John Harden, 135")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Daffodil ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Narcissus pseudo-narcissus")]), _vm._v(" L.), by Walter Hood Fitch, 177")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Blotting paper in the Grasmere Journals, 203")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("The Grasmere Journals, May 29, 1802, 209")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Swallow, by Thomas Bewick, 217")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Entry for October 4, 1802, in the Grasmere Journals, 234")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("The road to Brompton from Gallow Hill, sketch in the Grasmere Journals, 240")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Final page of the Grasmere Journals, 260")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Rydal Mount, drawing by Dora Wordsworth, 269")]), _vm._v(" "), _c('p', {
    staticClass: "paraindent"
  }, [_vm._v("Dorothy in a wheelchair, drawing by John Harden, 1842, 275")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36568726","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter002.vue
// module id = 78
// module chunks = 0